<template>
  <!-- En el componente padre -->
  <div>
    <ReportePagos v-if="view === 'list'" @mtdBack="mtdBack" @mtd_show="mtd_show_detail" />
    <DetallePago v-if="view === 'detail'" :reportData="selectedReport" @mtdBack="view = 'list'" />
  </div>

</template>
<script>
import ReportePagos from "./ReportePagos.vue";
import DetallePago from "./DetallePago.vue";

export default {
  components: {
    ReportePagos,
    DetallePago
  },
  data() {
    return {
      view: "list",
      selectedReport: null
    };
  },
  methods: {
    // ...mapActions(["get", "post"]),
    mtdBack() {
      this.$emit("mtdBack");
    },
    mtd_show_detail(report) {
      this.selectedReport = report;
      this.view = "detail";
    }
  }
}
</script>